window.addEventListener('load', function() 
{


});